window.addEventListener('load', function() 
{


});